const {registerModule} = window;


class PostListFeatured {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUi();
    this.setVars();
    this.bindEvents();

    this.updateNavState();
    this.updateVisibleItems();
    this.updateDots();

    this.pageCount = Math.ceil( this.ui.$carouselItems.length / this.visibleItems );
    this.element.dataset.initialized = true;
  }

  bindUi() {
    this.ui = {};
    this.ui.$carousel = this.element.querySelector('[data-ref="list"]');
    this.ui.$carouselItems = this.ui.$carousel.querySelectorAll('[data-ref="list-item"]');
    this.ui.$dots = document.querySelector('[data-ref="dots"]');
    this.ui.$next = this.element.querySelector('[data-ref="next"]');
    this.ui.$prev = this.element.querySelector('[data-ref="prev"]');
  }

  bindEvents() {
    this.ui.$next.addEventListener( 'click', this.handleClickNext.bind( this ) );
    this.ui.$prev.addEventListener( 'click', this.handleClickPrev.bind( this ) );

    const options = {
      root: this.ui.$carousel,
      threshold: 0.75,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.dataset.isIntersecting = entry.isIntersecting;
      });

      this.updateVisibleItems();
      this.currentIndex = Array.from(this.ui.$carouselItems).indexOf(this.visibleItems[0]);
      this.updateNavState();
      this.updateDots();
    }, options);

    this.ui.$carouselItems.forEach(($carouselItem) => {
      observer.observe($carouselItem);
    });
  }

  handleClickNext() {
    this.nextIndex = this.currentIndex + this.visibleItemCount;
    if (this.nextIndex > this.ui.$carouselItems.length - 1) {
      // If the last item is already visible, we can stay in the same position
      this.nextIndex = this.currentIndex;
    }

    this.scrollItems();
  }

  handleClickPrev() {
    this.nextIndex = this.currentIndex - this.visibleItemCount;
    if (this.nextIndex < 0) {
      this.nextIndex = 0;
    }

    this.scrollItems();
  }

  scrollItems() {
    this.ui.$carouselItems[this.nextIndex].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    });

    this.nextIndex = undefined;
  }

  setVars() {
    this.currentIndex = 0; // index of the first visible card, updated automatically by IntersectionObserver
    this.nextIndex; // index of the card we're scrolling into view next, updated by click event handlers
    this.visibleItems = [];
    this.visibleItemCount = 0;
  }

  updateDots() {
    const currentPage = Math.ceil( this.currentIndex / this.visibleItemCount );
    this.ui.$dots.childNodes.forEach( (element, index) => {
      element.dataset.active = index === currentPage;
    });
  }

  updateNavState() {
    this.ui.$next.disabled = this.currentIndex + this.visibleItemCount >= this.ui.$carouselItems.length;
    this.ui.$prev.disabled = this.currentIndex === 0;
  }

  updateVisibleItems() {
    this.visibleItems = this.ui.$carousel.querySelectorAll('[data-is-intersecting="true"]');
    if (!this.visibleItemCount) {
      // Use the initial number of visible items to define how many items are
      // visible at any given time. This improves navigation away from the last
      // set of items.
      this.visibleItemCount = this.visibleItems.length;
    }
  }
}

registerModule('PostListFeatured', PostListFeatured);
